<template>
    <div>
        <div class="flex items-center w-full">
            <form class="flex justify-center mb-4 w-full md:w-1/2 m-auto">
                <div class="flex-grow">
                    <div class="mb-4">
                        <label
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                            for="codigo_reserva"
                        >
                            Código de reserva
                        </label>
                        <input
                            id="codigo_reserva"
                            name="codigo_reserva"
                            type="text"
                            placeholder="0ZHOXSG"
                            class="appearance-none block w-full text-gray-700 bg-white border border-gray py-3 px-4 leading-tight focus:outline-none"
                            v-model="form.codigo_reserva"
                        />
                        <p
                            class="text-red-600 text-xs italic"
                            v-show="errors.codigo_reserva"
                        >
                            {{ errors.codigo_reserva }}
                        </p>
                    </div>
                    <div class="mb-6">
                        <label
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                            for="patente"
                        >
                            Patente
                        </label>
                        <input
                            type="text"
                            id="patente"
                            name="patente"
                            placeholder="ABC123"
                            maxlength="6"
                            class="appearance-none block w-full text-gray-700 bg-white border border-gray py-3 px-4 leading-tight focus:outline-none"
                            v-model="form.patente"
                            @keyup.enter="validateAndSearch()"
                        />
                        <p
                            class="text-red-600 text-xs italic"
                            v-show="errors.patente"
                        >
                            {{ errors.patente }}
                        </p>
                    </div>
                    <div class="mb-6" v-show="errors.response">
                        <div
                            class="bg-orange-100 border-t-4 border-orange-500 rounded-b text-orange-900 px-4 py-3"
                            role="alert"
                        >
                            <div class="flex">
                                <div class="py-1">
                                    <svg
                                        class="fill-current h-6 w-6 text-orange-500 mr-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                    >
                                        <path
                                            d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
                                        />
                                    </svg>
                                </div>
                                <div>
                                    <p class="font-bold">
                                        No fue posible realizar la búsqueda.
                                    </p>
                                    <p class="text-sm">{{ errors.response }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex flex-wrap items-center justify-center md:justify-between"
                    >
                        <button
                            @click.prevent="validateAndSearch()"
                            class="w-full md:w-auto bg-blue-600 hover:bg-blue-800 text-white uppercase py-3 px-5 mb-4 focus:outline-none focus:shadow-outline"
                            type="button"
                        >
                            Buscar
                            <span class="p-2" v-show="isLoading()"
                                ><i class="fal fa-spinner fa-spin"></i
                            ></span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import YamahaApi from "../Api";
import Loader from "./mixins/Loader";

export default {
    name: "ConsultarReserva",
    mixins: [Loader],
    data() {
        return {
            Api: null,
            form: {
                codigo_reserva: null,
                patente: null
            },
            errors: {
                codigo_reserva: null,
                patente: null
            }
        };
    },
    methods: {
        clearErrors() {
            this.errors.codigo_reserva = null;
            this.errors.patente = null;
        },

        checkForm() {
            this.clearErrors();

            if (!this.form.codigo_reserva) {
                this.errors.email = "Por favor, ingrese su código de reserva.";
            }

            if (!this.form.patente) {
                this.errors.patente =
                    "Por favor, ingrese la patente de su moto.";
            }

            return !this.errors.codigo_reserva && !this.errors.patente;
        },

        validateAndSearch() {
            if (this.checkForm()) {
                this.doSearch();
            }
        },

        doSearch() {
            this.load();
            this.Api.instance
                .request({
                    url:
                        this.Api.endpointPrefix +
                        "/agendamiento/reserva/buscar",
                    method: "get",
                    params: {
                        id: this.form.codigo_reserva,
                        patente: this.form.patente
                    }
                })
                .then(response => {
                    if (response.data && response.data.id) {
                        this.$router.push({
                            path: "detalle-reserva/" + response.data.id
                        });
                    } else {
                        this.errors.response =
                            "Lo sentimos, pero no pudimos encontrar ninguna reserva con los datos proporcionados.";
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.errors.response = `En estos momentos no podemos atender su solicitud (Código YHA-${
                            error.response.status
                        })`;
                    }
                })
                .then(() => {
                    this.loadComplete();
                });
        }
    },
    created() {
        this.Api = new YamahaApi("BO");
    }
};
</script>
